export default __webpack_public_path__ + "static/media/vehicletrading.b4e18714.png";